/* eslint-disable react/no-array-index-key */
import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export default function BasicTable(props: { showHeader: boolean; tableData: unknown[] }) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="File data preview">
        {props?.showHeader && (
          <TableHead>
            {props.tableData && props.tableData.length > 0 && (
              <TableRow>
                {Object.keys(props.tableData[0]).map((x, index0) => (
                  <TableCell key={`p_${index0}_${x}`}>{x}</TableCell>
                ))}
              </TableRow>
            )}
          </TableHead>
        )}
        <TableBody>
          {props.tableData &&
            props.tableData.length > 0 &&
            props.tableData.map((row, index1) => (
              <TableRow
                key={`x_${index1}_${row}`}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                {row &&
                  Object.values(row).map((v, index2) => (
                    <TableCell key={`j_${index2}_${v}`} component="th" scope="row">
                      {String(v)}
                    </TableCell>
                  ))}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
